import { Inbox } from "lucide-react";
import type * as React from "react";

import { cn } from "@/lib/utils";

/** C25 批1(1.7):加载/空态统一件——收编 33 处"加载中…"裸文字与各写空态。 */

export function Spinner({ className }: { className?: string }) {
	return (
		<span
			className={cn(
				"inline-block h-4 w-4 animate-spin rounded-full border-2 border-surface-border border-t-brand-accent",
				className,
			)}
			aria-label="加载中"
		/>
	);
}

export function LoadingInline({ text = "加载中…" }: { text?: string }) {
	return (
		<div className="flex items-center gap-2 py-4 text-sm text-text-muted">
			<Spinner />
			{text}
		</div>
	);
}

export function EmptyState({
	icon,
	title,
	desc,
	action,
	className,
}: {
	icon?: React.ReactNode;
	title: React.ReactNode;
	desc?: React.ReactNode;
	action?: React.ReactNode;
	className?: string;
}) {
	return (
		<div className={cn("flex flex-col items-center gap-1.5 py-10 text-center", className)}>
			<span className="text-text-muted">{icon ?? <Inbox className="h-6 w-6" />}</span>
			<div className="text-sm font-medium text-text-primary">{title}</div>
			{desc ? <div className="max-w-md text-xs text-text-muted">{desc}</div> : null}
			{action ? <div className="pt-2">{action}</div> : null}
		</div>
	);
}
